import api from "../utils/api";
import { getEncryptor, getMarketCountry } from "./siteService";
import { S_AUTH_TOKEN, webStorage } from "../utils/webStorage";
import { multiBindConsents } from "./consentService";
import getSiteInfo from "../utils/getSiteInfo";
import { isArray } from "lodash";
import { num } from "../utils";
import "./userService.apidoc.js";

export const bindCreateAccountConsents = async ({ email, countryCode, newsletterConsentNo, termsAndConditionNos, wantsNewsletter }) => {
  const consentNos = [...termsAndConditionNos];
  wantsNewsletter && consentNos.push(newsletterConsentNo);
  return await multiBindConsents(email, countryCode, consentNos);
};

export const getToken = async (email, password) => {
  const encryptor = await getEncryptor(email);
  const { obj: token } = await api.auth.token(null, {
    username: email,
    password: encryptor.encrypt(password)
  });
  return token;
};
export const getUserInfo = async () => {
  const token = webStorage.get(S_AUTH_TOKEN);
  const siteInfo = await getSiteInfo();
  if (token) {
    const { obj: user } = await api.account.detail(null, {
      account: token.userAccount,
      dateFormat: siteInfo.dateFormat
    });
    return user;
  } else {
    return null;
  }
};
export const updateEmail = async (userAccount, oldEmail, newEmail, code) => {
  await api.email.update(null, {
    userAccount: userAccount,
    code: code,
    email: newEmail
  });
  api.consent.email
    .update(null, {
      boundEmail: oldEmail,
      newEmail: newEmail
    })
    .then();
};
export const sendResetPasswordLinkToEmail = async (lang, email) => {
  await api.password.resetlink(null, {
    email: email
  });
};
/**
 *
 * @return {Promise<Array.<BankCard>>}
 */
export const getBankCards = async () => {
  const { obj } = await api.user.getBankCard();
  if (obj && Array.isArray(obj)) {
    obj.forEach(x => {
      x.formattedExpireDate = x.expirationMonth && x.expirationYear ? `${num.padding(x.expirationMonth, 2)}-${x.expirationYear}` : "";
    });
  }
  return obj;
};
export const getBankCardOptions = async () => {
  const data = await getBankCards();
  return data.map((x, i) => {
    const nextCard = i < data.length - 1 ? data[i + 1] : data[0];
    return {
      value: x.id,
      data: x,
      nextCard
    };
  });
};
export const getUserIdentity = async () => {
  const token = webStorage.get(S_AUTH_TOKEN);
  const siteInfo = await getSiteInfo();
  const { obj } = await api.user.identity.get(null, {
    account: token?.userAccount,
    dateFormat: siteInfo?.dateFormat
  });
  return obj;
};
/**
 * @function updateUserIdentity
 * @param {Object} fields
 * @param {UserIdentity} userIdentity
 * @param {PdpPersonalInfo} personalInfo
 * @param {PdpBillingInfo} billingInfo
 * @return {Promise<*>}
 */
export const updateUserIdentity = async (fields, userIdentity, personalInfo, billingInfo) => {
  const { placeOfBirthHeading } = fields;
  const siteInfo = await getSiteInfo();
  const marketCountry = await getMarketCountry();
  const countryIdentityInfo = userIdentity.countryIdentityInfo && isArray(userIdentity.countryIdentityInfo) ? [...userIdentity.countryIdentityInfo] : [];
  const idInfo = countryIdentityInfo.find(x => x.idType === personalInfo.idType && x.orgId === Number(siteInfo.organization));
  if (idInfo) {
    idInfo.idNumber = personalInfo.idNumber;
  } else {
    countryIdentityInfo.push({
      idType: personalInfo.idType,
      idNumber: personalInfo.idNumber,
      orgId: siteInfo.organization
    });
  }
  if (personalInfo.ssn) {
    const ssnInfo = countryIdentityInfo.find(x => x.idType === "IDTYPE03" && x.orgId === Number(siteInfo.organization));
    if (ssnInfo) {
      ssnInfo.idNumber = personalInfo.ssn;
    } else {
      countryIdentityInfo.push({
        idType: "IDTYPE03",
        idNumber: personalInfo.ssn,
        orgId: siteInfo.organization
      });
    }
  }
  const body = {
    addressId: billingInfo.addressId || userIdentity.addressId,
    userAccount: userIdentity.userAccount,
    firstName: personalInfo.firstName,
    lastName: personalInfo.lastName,
    gender: personalInfo.gender || userIdentity.gender,
    postalCode: billingInfo.postalCode,
    orgId: siteInfo.organization,
    countryId: marketCountry.regionId + "" || userIdentity.countryId,
    countryCode: marketCountry.regionAbbr || userIdentity.countryCode,
    country: marketCountry.regionName || userIdentity.country,
    province: null,
    city: billingInfo.city,
    county: null,
    street: billingInfo.street,
    apartment: billingInfo.apartment,
    birthday: personalInfo.birthday || userIdentity.birthday,
    cityOfBirth: personalInfo.cityOfBirth,
    provinceOfBirth: personalInfo.provinceOfBirth,
    countryOfBirth: personalInfo.countryOfBirth,
    postalCodeOfBirth: personalInfo.postalCodeOfBirth,
    countryIdentityInfo,
    dateFormat: siteInfo.dateFormat
  };
  if (placeOfBirthHeading.value) {
    Object.assign(body, {
      cityOfBirth: personalInfo.cityOfBirth,
      provinceOfBirth: personalInfo.provinceOfBirth,
      countryOfBirth: personalInfo.countryOfBirth
    });
  } else {
    Object.assign(body, {
      cityOfBirth: userIdentity.cityOfBirth,
      provinceOfBirth: userIdentity.provinceOfBirth,
      countryOfBirth: userIdentity.countryOfBirth
    });
  }
  console.log("save body", body);
  const { obj } = await api.user.identity.update(null, body);
  return obj;
};
